export class TrasladoMetrobolsa {
    _id_traslado: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    direccion_origen: String;
    id_comuna_origen: String;
    numero_cliente: String;
    direccion_destino: String;
    id_comuna_destino: String;
    numero_cliente_destino: String;
    archivo_rut_solicitante: String;
    archivo_rut_solicitante_reverso: String;
    archivo_cartola_voucher: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
 }